import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from '@services/logger.service';
import { RentalPracticeService } from '@services/data-source-tables/rentals/rental-practice.service';
import { RentalReservationService } from '@services/data-source-tables/rentals/rental-reservation.service';
import { BrandModel } from '@/models/tables/brand.model';
import { RentalPracticeModel } from '@/models/rental-practice.model';

export interface DialogLinkPracticeData {
  reservationId: number;
  marcaId?: number | null;
}

@Component({
  selector: 'app-dialog-link-practice',
  templateUrl: './dialog-link-practice.component.html',
  styleUrls: ['./dialog-link-practice.component.scss'],
})
export class DialogLinkPracticeComponent implements OnInit {
  brands: BrandModel[] = [];
  selectedBrandId: number | null = null;
  practices: RentalPracticeModel[] = [];
  loading = false;
  linkingId: number | null = null;
  displayedColumns: string[] = ['codicePratica', 'targa', 'marca', 'flotta', 'modello', 'actions'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogLinkPracticeData,
    private dialogRef: MatDialogRef<DialogLinkPracticeComponent, boolean>,
    private rentalPracticeService: RentalPracticeService,
    private rentalReservationService: RentalReservationService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.selectedBrandId = this.data?.marcaId ?? null;
    this.loadBrands();
    this.loadPractices();
  }

  onBrandChange(marcaId: number | null): void {
    this.selectedBrandId = marcaId;
    this.loadPractices();
  }

  onLink(practice: RentalPracticeModel): void {
    if (!practice?.id || this.linkingId !== null) {
      return;
    }

    this.linkingId = practice.id;

    this.rentalReservationService.linkToPractice(this.data.reservationId, practice.id).subscribe({
      next: () => {
        this.toastr.success('Prenotazione collegata alla pratica con successo!');
        this.dialogRef.close(true);
      },
      error: (error) => {
        LoggerService.error('linkToPractice failed!');
        LoggerService.error(error);
        this.toastr.error('Errore nel collegamento della prenotazione alla pratica.');
        this.linkingId = null;
      },
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  private loadBrands(): void {
    this.rentalReservationService.getBrands().subscribe({
      next: (brands: BrandModel[]) => {
        this.brands = brands ?? [];
      },
      error: (error) => {
        LoggerService.error('loadBrands failed!');
        LoggerService.error(error);
      },
    });
  }

  private loadPractices(): void {
    this.loading = true;

    this.rentalPracticeService
      .getActiveRentalPracticesByMarcaId(this.selectedBrandId ?? undefined)
      .subscribe({
        next: (practices: RentalPracticeModel[]) => {
          this.practices = practices ?? [];
          this.loading = false;
        },
        error: (error) => {
          LoggerService.error('loadPractices failed!');
          LoggerService.error(error);
          this.practices = [];
          this.loading = false;
        },
      });
  }
}
